import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Popup,
  Form,
  Input,
  Icon,
  Header,
  Dropdown,
  Divider,
} from 'semantic-ui-react';
import cn from 'classnames';

import { CacheInputs, Portfolio, Planning } from 'actions';
import { colors } from 'utils/colors';
import { isGlobeInvestor } from 'utils/helpers';
import {
  Loading,
  Segment,
  YouTubePlayer,
  ErrorLabel,
  Button,
} from 'components';
import PortfoliosList from '../components/PortfoliosList';
import Result from './Result';

class TargetWealth extends Component {
  componentWillMount = () => {
    const { dispatch, portfolios } = this.props;

    return !portfolios.length ? dispatch(Portfolio.fetchModel()) : false;
  };

  toggleVideo = (target) =>
    this.props.dispatch(
      CacheInputs.updateField('planning', 'target_wealth', {
        video: target === this.props.targetWealthInputs.video ? false : target,
      })
    );

  handleChange = (e, { name, value }) => {
    const { dispatch, targetWealthInputs } = this.props;
    const { errors } = targetWealthInputs;

    if (name !== 'gender') {
      const limitRegex = /^[0-9]{1,9}$/;
      if (value !== '' && !limitRegex.test(value)) return;
      if (name === 'age' || name === 'retAge') {
        const num = value > 100 ? 100 : Number(value);

        // eslint-disable-next-line consistent-return
        return dispatch(
          CacheInputs.updateField('planning', 'target_wealth', {
            [name]: num,
            errors: { ...errors, [name]: null },
          })
        );
      }
      dispatch(
        CacheInputs.updateField('planning', 'target_wealth', {
          [name]: value,
          errors: { ...errors, [name]: null },
        })
      );
    } else {
      dispatch(
        CacheInputs.updateField('planning', 'target_wealth', {
          [name]: value,
          errors: { ...errors, [name]: null },
        })
      );
    }
  };

  handlePortfolioChange = (e, { name, value }) => {
    const { dispatch, targetWealthInputs } = this.props;
    const { errors } = targetWealthInputs;

    dispatch(Planning.clearSectionData('wealthResult'));

    const limitRegex = /^[0-9]{1,9}(\.[0-9]{0,2})?$/;
    if (name === 'annuityRate') {
      if (value === '' || value === null) {
        dispatch(
          CacheInputs.updateField('planning', 'target_wealth', {
            ...this.props.targetWealthInputs,
            wealth_portfolio: null,
            modelType: 'annuityRate',
            targ: null,
            annuityRate: null,
          })
        );
        return;
      }

      if (!limitRegex.test(value)) {
        return;
      }

      const num = Number(value) > 100 ? 100 : value;

      dispatch(
        CacheInputs.updateField('planning', 'target_wealth', {
          ...this.props.targetWealthInputs,
          wealth_portfolio: null,
          modelType: 'annuityRate',
          annuityRate: num,
          targ: null,
        })
      );
    } else {
      dispatch(
        CacheInputs.updateField('planning', 'target_wealth', {
          ...this.props.targetWealthInputs,
          wealth_portfolio: value,
          modelType: name,
          annuityRate: null,
          targ: null,
        })
      );
    }
    dispatch(
      CacheInputs.updateField('planning', 'target_wealth', {
        errors: {
          ...errors,
          portfolioID: null,
        },
      })
    );
  };

  handleRadioChange = (e, { value }) => {
    const { dispatch, targetWealthInputs } = this.props;
    const { errors } = targetWealthInputs;
    dispatch(Planning.clearSectionData('wealthResult'));

    dispatch(
      CacheInputs.updateField('planning', 'target_wealth', {
        modelType: value,
        annuityRate: null,
        errors: { ...errors, portfolioID: null },
      })
    );
  };

  hasEmptyValue = (values) =>
    values.some((field) => {
      const { dispatch, targetWealthInputs } = this.props;

      if (!targetWealthInputs[field]) {
        this.scrollHandler(document.documentElement, -20000, 600);
        return dispatch(
          CacheInputs.updateField('planning', 'target_wealth', {
            errors: { [field]: 'This field is required' },
          })
        );
      }

      return false;
    });

  handleDeclinePatternChange = (e) => {
    const { dispatch, targetWealthInputs } = this.props;
    const { errors } = targetWealthInputs;
    const { name, value } = e.target;
    const num = value > 100 ? 100 : Number(value);

    return dispatch(
      CacheInputs.updateField('planning', 'target_wealth', {
        [name]: num,
        errors: { ...errors, [name]: null },
      })
    );
  };

  handleSubmit = () => {
    const { portfolios, dispatch, targetWealthInputs, user_region } =
      this.props;
    const {
      annuityRate,
      age,
      retAge,
      gender,
      cf3,
      total,
      cpp = 0,
      oas = 0,
      declinePattern,
      declinePatternPercent,
      declinePatternDuration,
      modelType,
      wealth_portfolio,
    } = targetWealthInputs;
    const cppAge = retAge < 60 ? 60 : retAge;
    const oasAge = retAge < 65 ? 65 : retAge;
    const params = {
      gender,
      exp: total || cf3,
      cpp,
      cppAge,
      oas,
      oasAge,
      age,
      retAge,
      ...(declinePattern && {
        declinePattern: {
          percent: declinePatternPercent,
          duration: declinePatternDuration,
        },
      }),
    };
    const userInputs = {
      age,
      retAge,
      gender,
      cf3,
      ...(declinePattern && {
        declinePatternPercent,
        declinePatternDuration,
      }),
    };

    if (this.hasEmptyValue(Object.keys({ ...userInputs }))) return false;

    if (retAge < age) {
      this.scrollHandler(document.documentElement, -20000, 600);
      return dispatch(
        CacheInputs.updateField('planning', 'target_wealth', {
          errors: { retAge: 'Retirement age can not be less than current age' },
        })
      );
    }

    if (
      (wealth_portfolio === null || wealth_portfolio === undefined) &&
      modelType !== 'annuityRate'
    ) {
      return dispatch(
        CacheInputs.updateField('planning', 'target_wealth', {
          errors: { portfolioID: 'Please select a portfolio.' },
        })
      );
    }

    if (!annuityRate && annuityRate !== 0 && modelType === 'annuityRate') {
      return dispatch(
        CacheInputs.updateField('planning', 'target_wealth', {
          errors: { portfolioID: 'Please enter a risk-free rate.' },
        })
      );
    }

    if (annuityRate || annuityRate === 0) {
      return dispatch(
        Planning.analyzeWealth({
          ...params,
          region: user_region,
          annuityRate: annuityRate / 100,
        })
      ).then(() =>
        this.scrollHandler(
          document.documentElement,
          document.getElementById('ref').offsetHeight,
          600
        )
      );
    }
    const selectedPortfolio = portfolios.find(
      (port) => port.id === Number(wealth_portfolio)
    );

    return dispatch(
      Planning.analyzeWealth({
        symbols: selectedPortfolio.symbols,
        weights: selectedPortfolio.weights,
        region: selectedPortfolio.region,
        gic_info: selectedPortfolio.gic_info,
        ...params,
      })
    ).then(() =>
      this.scrollHandler(
        document.documentElement,
        document.getElementById('ref').offsetHeight,
        600
      )
    );
  };

  scrollHandler = (element, to, duration) => {
    if (duration <= 0) return false;
    const difference = to - element.scrollTop;
    const perTick = (difference / duration) * 10;

    return setTimeout(() => {
      element.scrollTop += perTick;
      // for safari compatibility
      if (element.scrollTop === 0) {
        document.body.scrollTop += perTick;
      }
      if ((element.scrollTop || document.body.scrollTop) >= to) return false;
      return this.scrollHandler(element, to, duration - 10);
    }, 10);
  };

  renderSubHeaderWithVideo = () => (
    <div className="sub header">
      In this segment, you can calculate the level of wealth you need at
      retirement in order to sustain your post-retirement spending needs.
      <Icon
        name="youtube play"
        onClick={() => this.toggleVideo('3QM5prvkO0M')}
        link
        style={{ color: 'rgb(255,2,2)', marginLeft: '3px' }}
      />
      <YouTubePlayer
        isOpen={this.props.targetWealthInputs.video === '3QM5prvkO0M'}
        id="3QM5prvkO0M"
        style={{ margin: '10px 0' }}
      />
    </div>
  );

  render() {
    const {
      portfolios,
      isFetching,
      dispatch,
      targetWealthInputs,
      user_region,
      partnerName,
    } = this.props;
    const {
      portfolioID,
      annuityRate,
      age,
      retAge,
      gender,
      cf3,
      declinePattern,
      declinePatternPercent,
      declinePatternDuration,
      errors,
      modelType,
    } = targetWealthInputs;

    return (
      <div>
        <Segment>
          <div id="ref">
            <Loading active={!portfolios.length} />

            <Header
              textAlign="center"
              size="large"
              content="Target Wealth"
              subheader={this.renderSubHeaderWithVideo()}
              style={{ marginBottom: '1rem' }}
            />

            <StyledForm
              style={{
                width: '85%',
                maxWidth: '963px',
                margin: '2rem auto 0 auto',
                textAlign: 'left',
              }}
            >
              <Header
                size="medium"
                content="Enter Your Inputs"
                textAlign="left"
                style={{ marginBottom: '1rem' }}
              />
              <Form.Group widths="equal">
                <Form.Field style={{ position: 'relative' }}>
                  <StyledLabel>Current age:</StyledLabel>
                  <Input
                    name="age"
                    value={age || ''}
                    placeholder="Enter value..."
                    label={{ basic: true, content: 'years' }}
                    labelPosition="right"
                    onChange={this.handleChange}
                  />
                  <ErrorLabel className="top" msg={errors.age} />
                </Form.Field>
                <Form.Field style={{ position: 'relative' }}>
                  <StyledLabel>Retirement age:</StyledLabel>
                  <Input
                    name="retAge"
                    value={retAge || ''}
                    placeholder="Enter value..."
                    label={{ basic: true, content: 'years' }}
                    labelPosition="right"
                    onChange={this.handleChange}
                  />
                  <ErrorLabel className="bottom" msg={errors.retAge} />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field style={{ position: 'relative' }}>
                  <StyledLabel>
                    Sex:
                    <Popup
                      trigger={<Icon name="question circle outline" />}
                      position="bottom center"
                      style={{ height: 'initial' }}
                    >
                      {user_region === 'CA'
                        ? 'We are using mortality rates from Statistics Canada in the calculations and the data is available for males and females only.'
                        : 'We are using mortality rates from the National Center for Health Statistics in the calculations and the data is available for males and females only.'}
                    </Popup>
                  </StyledLabel>
                  <Dropdown
                    selection
                    options={[
                      { key: 'm', value: 'M', text: 'Male' },
                      { key: 'f', value: 'F', text: 'Female' },
                    ]}
                    name="gender"
                    value={gender}
                    placeholder="Select ..."
                    onChange={this.handleChange}
                    style={{ minWidth: 100 }}
                  />
                  <ErrorLabel className="top" msg={errors.gender} />
                </Form.Field>
                <Form.Field style={{ position: 'relative' }}>
                  <StyledLabel style={{ minWidth: '18rem' }}>
                    Annual spending amount:{' '}
                    <Popup
                      trigger={<Icon name="question circle outline" />}
                      position="bottom center"
                      style={{ height: 'initial' }}
                    >
                      Including expected taxes payable.
                    </Popup>
                  </StyledLabel>
                  <Input
                    name="cf3"
                    value={!cf3 && cf3 !== 0 ? '' : cf3}
                    placeholder="Enter value..."
                    icon="dollar"
                    iconPosition="left"
                    onChange={this.handleChange}
                  />
                  <SubLabel>
                    NET OF expected (before-tax) retirement income
                  </SubLabel>

                  <ErrorLabel className="bottom" msg={errors.cf3} />
                </Form.Field>
              </Form.Group>

              <DeclineBox>
                <DeclineText>
                  This amount will stay constant in real terms. However, you may
                  have heard of references to the "go-go", "slow-go", and
                  "no-go" phases of retirement, i.e., the idea that your
                  spending needs may drop as you age, when activities are
                  gradually reduced.
                </DeclineText>

                <DeclineQuestionRow>
                  <DeclineQuestion>
                    Do you want to incorporate this consideration into the
                    simulations?
                  </DeclineQuestion>
                  <div style={{ flexShrink: 0 }}>
                    <StyledSpan
                      active={!!declinePattern}
                      onClick={() => {
                        if (!declinePattern) {
                          dispatch(
                            CacheInputs.updateField(
                              'planning',
                              'target_wealth',
                              {
                                declinePattern: true,
                                declinePatternPercent: null,
                                declinePatternDuration: null,
                              }
                            )
                          );
                        }
                      }}
                    >
                      Yes
                    </StyledSpan>
                    <StyledSpan
                      active={!declinePattern}
                      onClick={() => {
                        if (declinePattern) {
                          dispatch(
                            CacheInputs.updateField(
                              'planning',
                              'target_wealth',
                              {
                                declinePattern: false,
                                declinePatternPercent: null,
                                declinePatternDuration: null,
                              }
                            )
                          );
                        }
                      }}
                    >
                      No
                    </StyledSpan>
                  </div>
                </DeclineQuestionRow>

                {declinePattern ? (
                  <DeclineInputsRow>
                    <DeclineInputsLabel>
                      Assume that your spending needs will drop by
                      <Popup
                        trigger={
                          <Icon
                            name="question circle outline"
                            style={{
                              fontSize: '15px',
                              verticalAlign: 'initial',
                              color: 'dimgrey',
                              marginLeft: '6px',
                            }}
                          />
                        }
                        position="top center"
                        wide
                        content="For example, drop by 10% every 10 years."
                      />
                    </DeclineInputsLabel>
                    <div style={{ position: 'relative' }}>
                      <DeclinePatternInput
                        name="declinePatternPercent"
                        value={declinePatternPercent || ''}
                        placeholder="Enter value..."
                        label={{ basic: true, content: '%' }}
                        labelPosition="right"
                        onChange={this.handleDeclinePatternChange}
                      />
                      <ErrorLabel
                        className="bottom"
                        msg={errors.declinePatternPercent}
                      />
                    </div>
                    <DeclineInputsLabel>every</DeclineInputsLabel>
                    <div style={{ position: 'relative' }}>
                      <DeclinePatternInput
                        name="declinePatternDuration"
                        value={declinePatternDuration || ''}
                        placeholder="Enter value..."
                        label={{ basic: true, content: 'years' }}
                        labelPosition="right"
                        onChange={this.handleDeclinePatternChange}
                      />
                      <ErrorLabel
                        className="bottom"
                        msg={errors.declinePatternDuration}
                      />
                    </div>
                  </DeclineInputsRow>
                ) : null}
              </DeclineBox>
            </StyledForm>
            <div
              style={{
                width: '85%',
                maxWidth: '963px',
                margin: '2rem auto 0 auto',
                textAlign: 'left',
              }}
            >
              <Divider />

              <Header
                size="medium"
                textAlign="left"
                content="Select a Model Portfolio"
                style={{ margin: '2rem auto 1rem auto', position: 'relative' }}
              />
              {isGlobeInvestor(partnerName) ? (
                <div
                  style={{
                    textAlign: 'left',
                    maxWidth: '45rem',
                    margin: '0',
                    color: 'rgba(0,0,0,0.6)',
                    fontSize: '15px',
                  }}
                >
                  Choose a portfolio for your <b>post</b>-retirement years.
                  <br />
                  <br />
                  Withdrawals are assumed to occur at the beginning of each year
                  to fund spending needs, with the remaining assets staying
                  invested. There are five simple index model portfolios below,
                  using a combination of Canadian universe bond and equity (50%
                  Canadian and 50% U.S.) ETFs.
                </div>
              ) : (
                <div
                  style={{
                    textAlign: 'left',
                    maxWidth: '45rem',
                    margin: '0',
                    color: 'rgba(0,0,0,0.6)',
                    fontSize: '15px',
                  }}
                >
                  Choose a portfolio for your <b>post</b>-retirement years.
                  <br />
                  <br />
                  Withdrawals are assumed to occur at the beginning of each year
                  to fund spending needs, with the remaining assets staying
                  invested. Select a model portfolio that best reflects your
                  post-retirement investment strategy. Details of the
                  Wealthscope (WS) model portfolios can be found in the
                  "Portfolios" segment.
                </div>
              )}

              <div style={{ position: 'relative', marginTop: '1rem' }}>
                <PortfoliosList
                  portfolios={portfolios}
                  portfolioID={portfolioID ? portfolioID.toString() : null}
                  annuityRate={annuityRate}
                  handlePortfolioChange={this.handlePortfolioChange}
                  handleRadioChange={this.handleRadioChange}
                  modelType={modelType || ''}
                  style={{ margin: 'initial' }}
                  user_region={user_region}
                  partnerName={partnerName}
                />
                <ErrorLabel
                  className="bottom"
                  msg={errors.portfolioID}
                  style={{ top: '130%' }}
                />
              </div>
            </div>

            <Button
              className={cn('right centered', { loading: isFetching })}
              color={colors.teal}
              icon="calculator"
              onClick={this.handleSubmit}
              style={{ marginTop: '2rem' }}
            >
              Calculate
            </Button>
          </div>
          <Result />
        </Segment>
      </div>
    );
  }
}

TargetWealth.propTypes = {
  dispatch: PropTypes.func.isRequired,
  portfolios: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  targetWealthInputs: PropTypes.object,
  user_region: PropTypes.string,
  partnerName: PropTypes.string,
};

TargetWealth.defaultProps = {
  portfolios: [],
  targetWealthInputs: {},
  user_region: 'CA',
  partnerName: '',
};

export default withRouter(
  connect((state) => ({
    isFetching: state.Planning.isFetching,
    portfolios: state.Portfolio.model,
    targetWealthInputs: state.CacheInputs.planning.target_wealth,
    user_region: state.Storage.user_region || 'CA',
    partnerName: state.Storage['partner-name'],
  }))(TargetWealth)
);

const StyledLabel = styled.label`
  text-align: left;
`;

// Solid-teal toggle (matches the Longevity tool)
const StyledSpan = styled.span`
  padding: 0.3rem 0.7rem;
  cursor: pointer;
  font-size: 14px;
  background-color: ${(props) => (props.active ? colors.teal : 'white')};
  border: ${(props) =>
    props.active ? '1px solid transparent' : '1px solid #dcdcdc'};
  user-select: none;

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  &:hover {
    border: 1px solid ${colors.teal};
  }
`;

const DeclineBox = styled.div`
  margin-top: 1.5rem;
  padding: 1.5rem 1.75rem;
  background: #f7f7f9;
  border: 1px solid #e8e8ec;
  border-radius: 8px;
`;

const DeclineText = styled.p`
  color: rgba(0, 0, 0, 0.6);
  font-size: 15px;
`;

const DeclineQuestionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.25rem;
`;

const DeclineQuestion = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  padding-right: 1rem;
`;

const DeclineInputsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 1.25rem;
  padding: 0.75rem 0 0.75rem 1.25rem;
  border-left: 2px solid #bfe0e8;

  > * {
    margin-right: 1rem;
  }
`;

const DeclineInputsLabel = styled.div`
  font-size: 15px;
  color: rgba(0, 0, 0, 0.7);
  white-space: nowrap;
`;

const DeclinePatternInput = styled(Input)`
  width: 180px !important;

  input {
    width: 60px !important;
    flex: 1 1 auto !important;
  }

  .label {
    background: #f1f1f4 !important;
    color: rgba(0, 0, 0, 0.6) !important;
    min-width: 55px;
    text-align: center;
  }
`;

const StyledForm = styled(Form)`
  &&& .field > label {
    font-size: 16px;
  }
`;

const SubLabel = styled.div`
  color: rgba(0, 0, 0, 0.5);
  line-height: 0.8rem;
  font-style: italic;
  font-weight: 100;
  font-size: 16px;
  margin-top: 1rem;
`;
